var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.7617H3.5C3.22386 12.7617 3 13.0602 3 13.4284V20.0951C3 20.4632 3.22386 20.7617 3.5 20.7617H6.5C6.77614 20.7617 7 20.4632 7 20.0951V13.4284C7 13.0602 6.77614 12.7617 6.5 12.7617Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3.23779H17.5C17.2239 3.23779 17 3.63008 17 4.114V19.8856C17 20.3696 17.2239 20.7618 17.5 20.7618H20.5C20.7761 20.7618 21 20.3696 21 19.8856V4.114C21 3.63008 20.7761 3.23779 20.5 3.23779Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.62354H10.5C10.2239 8.62354 10 8.81763 10 9.05705V20.3284C10 20.5678 10.2239 20.7619 10.5 20.7619H13.5C13.7761 20.7619 14 20.5678 14 20.3284V9.05705C14 8.81763 13.7761 8.62354 13.5 8.62354Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.c93eb13536c55d3d3b253a2ed2a6fba2.svg";
export { ForwardRef as ReactComponent };